import type { Editor } from '@tiptap/react';

export interface EditorSelectionRange {
  from: number;
  to: number;
}

export function normalizeEditorLinkUrl(url: string): string {
  const trimmed = url.trim();
  if (!trimmed) {
    return trimmed;
  }

  if (/^[a-z][a-z0-9+.-]*:/i.test(trimmed)) {
    return trimmed;
  }

  return `https://${trimmed}`;
}

export function applyEditorLink(
  editor: Editor,
  url: string,
  options: {
    text?: string;
    openInNewTab?: boolean;
    selection?: EditorSelectionRange;
  } = {},
): boolean {
  const href = normalizeEditorLinkUrl(url);
  if (!href) {
    return false;
  }

  const target = options.openInNewTab ? '_blank' : null;
  const selection = options.selection ?? {
    from: editor.state.selection.from,
    to: editor.state.selection.to,
  };
  const { from, to } = selection;
  const hasSelection = from !== to;

  if (hasSelection) {
    return editor
      .chain()
      .focus()
      .setTextSelection({ from, to })
      .setLink({ href, target })
      .run();
  }

  const linkText = options.text?.trim() ? options.text.trim() : href;

  return editor
    .chain()
    .focus()
    .setTextSelection({ from, to })
    .insertContent({
      type: 'text',
      text: linkText,
      marks: [
        {
          type: 'link',
          attrs: { href, target },
        },
      ],
    })
    .run();
}
